import React from 'react'
import HeroHeadline from '../../Components/HeroHeadline'
import { Box } from '@mui/material'
import Breadcrumb from './Breadcrumb'
import LinkedinBlogs from './BlogDetails/LinkedinBlogs'
import BlogSection from './BlogSection'
import Banner from './Banner'

const Blog:React.FC = () => {
  return (
    <Box>
          {/* <Breadcrumb/> */}
          <Banner/>
          {/* <BlogSlider/> */}
          <BlogSection/>
          {/* <LinkedinBlogs/> */}
      
    </Box>
  )
}

export default Blog
